import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

export default function AdminConnectedWallets() {
  const { data, isLoading } = useQuery(
    'admin-connected-wallets',
    async () => await apiClient.get('/api/admin/connected-wallets'),
    { enabled: true }
  );
  const list = data?.data?.connected_wallets || [];

  const formatDate = (d) => (d ? new Date(d).toLocaleString() : '-');

  return (
    <div style={{ marginTop: '75px' }}>
      <Container>
        <Typography sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase', mb: 2 }} variant="h6">
          Connected wallet addresses (submitted by users)
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Wallet</TableCell>
                <TableCell>Address</TableCell>
                <TableCell align="right">Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.user?.name ?? '-'}</TableCell>
                  <TableCell>{row.user?.email ?? '-'}</TableCell>
                  <TableCell>
                    <Typography variant="body2">{row.wallet_option?.name ?? '-'}</Typography>
                    {row.wallet_option?.image_url && (
                      <Avatar src={row.wallet_option.image_url} sx={{ width: 24, height: 24, mt: 0.5 }} variant="rounded" />
                    )}
                  </TableCell>
                  <TableCell sx={{ maxWidth: 280, wordBreak: 'break-all' }}>{row.address}</TableCell>
                  <TableCell align="right">{formatDate(row.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!isLoading && list.length === 0 && (
          <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
            No connected wallet submissions yet.
          </Typography>
        )}
      </Container>
    </div>
  );
}
